import { GlAccountTypeOption } from '@/utils/constants';
import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire, validatorConditionalRequiredNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    type: {
      type: Select,
      defaultValue: GlAccountTypeOption.ClientSales,
      props: {
        caption: 'common.type',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('glAccountType'),
        required: true
      },
      dynamicProps: form => {
        return {
          readonly: form.id > 0
        };
      }
    },
    glAccountNumber: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'common.glAccountNumber',
        maxlength: 8,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    exactInstanceID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.exactInstance',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['exactInstance/isLoading'],
        options: vue.$store.getters['exactInstance/loadedItems']
      },
      dynamicProps: form => {
        const isIntercompanySales = form.type === GlAccountTypeOption.IntercompanySales;
        return { required: isIntercompanySales, visible: isIntercompanySales };
      },
      dynamicRules: form => [
        { validator: validatorConditionalRequiredNumber(form.type === GlAccountTypeOption.IntercompanySales) }
      ],
      valueOnFormChange: (form, oldValue) => {
        return form.type !== GlAccountTypeOption.IntercompanySales ? null : oldValue;
      }
    },
    workshopID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.workshop',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['workshop/isLoading'],
        options: vue.$store.getters['workshop/loadedItems']
      },
      dynamicProps: form => {
        const isIntercompanyPurchase = form.type === GlAccountTypeOption.IntercompanyPurchase;
        return { required: isIntercompanyPurchase, visible: isIntercompanyPurchase };
      },
      dynamicRules: form => [
        { validator: validatorConditionalRequiredNumber(form.type === GlAccountTypeOption.IntercompanyPurchase) }
      ],
      valueOnFormChange: (form, oldValue) => {
        return form.type !== GlAccountTypeOption.IntercompanyPurchase ? null : oldValue;
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return {
    ...item
  };
}
